export const isObject = (value: any): value is Object => 
    typeof value === "object"
;